import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  PageHeader,
  Spin,
  Button,
  Popconfirm,
  Row,
  Col,
  Form,
  Input,
  message,
  InputNumber,
} from "antd";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { guranteeService } from "_services";

function Summary({ match, history }) {
  const { id } = match.params;
  const { path } = match;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getGuranteeById(id);
  }, [id]);

  const getGuranteeById = (id) => {
    if (id == null || id == undefined) return;

    setLoading(true);
    guranteeService
      .getById(id)
      .then((data) => {
        onFill(data.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
      });
  };
  const onCancel = () => {
    history.push("/gurantees");
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const handleOnFormSubmit = (values) => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        guranteeService
          .update(id, values)
          .then((response) => {
            message.success("Successfully Updated!", 3);
            setLoading(false);
            history.push("/gurantees");
          })
          .catch((error) => {
            message.error(error);
            setLoading(false);
          });
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(<Button onClick={onCancel}>Cancel</Button>);
    buttons.push(
      <Popconfirm
        title={`Are you sure to Update it?`}
        onConfirm={handleOnFormSubmit}
        key="updateButtonKey"
      >
        <Button
          key="btn-update"
          type="primary"
          htmlType="button"
          loading={loading}
        >
          Update
        </Button>
      </Popconfirm>
    );

    return buttons;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashbaord</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to="/gurantees">Gurantees</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to={`${path}`.replace(":id", id)}>Summary</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Spin spinning={loading}>
        <Page inner>
          <Form name="form-edit" form={form}>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name={["guranteeType"]}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["currency", "name"]}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["value"]}>
                  <InputNumber addonAfter="LKR" defaultValue={100} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name={["currency", "id"]}>
                  <Input hidden />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["id"]}>
                  <Input hidden />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </Spin>
    </PageHeader>
  );
}

export default Summary;
